<template>
  <div class="limiter font-example">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
              :img="require('../../assets/background.png')"
              height="650px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-row dense style="margin-top: 300px" v-if="carregamento.estado == 'CARREGANDO'">
                    <v-col cols="12">
                      <v-progress-linear indeterminate rounded height="7" color="#E30613"></v-progress-linear>
                    </v-col>
                  </v-row>
                  <v-row dense style="margin-top: 250px; text-align: center" v-if="carregamento.estado == 'ERRO'">
                    <v-col cols="12">
                      <v-icon size="50" color="orange">mdi-alert</v-icon>
                      <p style="margin: 0px">{{ carregamento.texto }}</p>
                    </v-col>
                  </v-row>
                  <v-row dense style="margin-top: 0px; text-align: center" v-if="carregamento.estado == 'CARREGADO' && tipoExibicao == 'SELEÇÃO PRODUTO'">
                    <v-col cols="12" style="margin-top: 5px; text-align: center">
                      <img :src="empresa.logoUrl" width="130px">
                    </v-col>
                    <v-col cols="12" style="margin-top: 5px">
                      <p style="margin: 0px; color: #E30613; font-size: 22px; line-height: 25px; font-weight: bold">ESCOLHA A OPÇÃO DESEJADA</p>
                    </v-col>
                    <v-col cols="12" style="margin-top: 5px; text-align: center">
                      <v-virtual-scroll :items="produtos" item-height="90" height="420" :bench="produtos.length">
                        <template v-slot:default="{ item }">
                          <v-card color="#E30613" flat width="270px" class="mx-auto" style="border-radius: 22px" :height="item.detalhes ? '60px' : '50px'" @click="escolheProduto(item)">
                            <v-card-text style="padding: 5px">
                              <h1 style="margin: 10px 0px 0px 0px; color: white; font-size: 28px; letter-spacing: -2px">{{ item.descricao.toUpperCase() }}</h1>
                              <h6 v-if="item.detalhes" style="color: white; font-size: 11px">{{ item.detalhes }}</h6>
                            </v-card-text>
                          </v-card>
                          <v-card color="#FDB913" flat width="140px" class="mx-auto" style="margin-top: -7px; border-radius: 50px" @click="escolheProduto(item)">
                            <v-card-text style="padding: 4px">
                              <h2 style="margin: 0px; color: #000; font-size: 22px; letter-spacing: -2px">R$ {{ item.preco }}</h2>
                            </v-card-text>
                          </v-card>
                        </template>
                      </v-virtual-scroll>
                    </v-col>
                    <v-col cols="12" style="margin-top: 5px; text-align: center">
                      <v-btn depressed color="#E30613" outlined style="background-color: white" dark rounded @click="dialogoInsereVoucher = true">Usar voucher</v-btn>
                    </v-col>
                  </v-row>
                  <v-row dense style="margin-top: 20px; text-align: center" v-if="carregamento.estado == 'CARREGADO' && tipoExibicao == 'PAGAMENTO'">
                    <v-col cols="12">
                      <v-btn @click="voltaTelaSelecaoProdutos" color="#8B0000" small>
                        <v-icon color="white">mdi-arrow-left-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" style="margin-top: 5px">
                      <h2 style="color: #000; font-size: 34px; line-height: 40px">VOCÊ<br>SELECIONOU<br>{{ produtoSelecionado.descricao.toUpperCase() }}</h2>
                    </v-col>
                    <v-col cols="12">
                      <h2 style="color: #000; font-size: 30px; line-height: 30px">COMO DESEJA EFETUAR SEU PAGAMENTO?</h2>
                    </v-col>
                    <v-col cols="12" style="margin-top: 2px" v-if="cupom.existe">
                      <h2 style="color: #000; font-size: 20px; line-height: 22px">
                        R$ {{ produtoSelecionado.preco }} - R$ {{ cupom.valor }} de desconto referente a recarga anterior
                      </h2>
                      <h2 style="color: #000; font-size: 25px; line-height: 40px">
                        TOTAL: 
                        <span style="background-color: #FDB913; padding: 1px 5px 1px 5px">
                          R$ {{ (parseFloat(produtoSelecionado.preco.replace(',','.')) - parseFloat(cupom.valor.replace(',','.'))).toFixed(2).replace('.',',') }}
                        </span>
                      </h2>
                    </v-col>
                    <v-col cols="12" style="margin-top: 2px" v-else>
                      <h2 style="color: #000; font-size: 25px; line-height: 40px">TOTAL: <span style="background-color: #FDB913; padding: 1px 5px 1px 5px"> R$ {{ produtoSelecionado.preco }}</span></h2>
                    </v-col>
                    <v-row dense style="margin-top: 5px">
                      <v-col cols="12">
                        <v-btn block style="background: linear-gradient(to bottom, #FDB913, #E30613); border-radius: 10px" large depressed dark @click="dialogoPedeTelefone = true">
                          <img src="../../assets/pixIcon.png" alt="pixIcon" width="50px" style="margin-right: 5px; filter: Invert(1.0)">
                          <p style="margin: 0px; font-size: 25px">PIX</p>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <!-- <v-btn block style="background: linear-gradient(to bottom, #FDB913, #E30613); border-radius: 10px" large depressed dark @click="verificaValorCartao">
                          <img src="../../assets/cardIcon.png" alt="pixIcon" width="25px" style="margin-right: 5px; filter: Invert(1.0)">
                          <p style="margin: 0px; font-size: 25px">CARTÃO</p>
                        </v-btn> -->
                      </v-col>
                    </v-row>
                    <v-col cols="12" style="margin-top: 15px; text-align: center">
                      <img :src="empresa.logoUrl" width="130px">
                    </v-col>
                  </v-row>
                  <v-row dense style="margin-top: 130px; text-align: center" v-if="carregamento.estado == 'CARREGADO' && tipoExibicao == 'FINALIZADO'">
                    <v-col cols="12">
                      <img src="../../assets/bombinha.png" alt="bombinha" width="110px" style="margin-bottom: 10px">
                      <h2 style="color: #E30613; font-size: 25px; line-height: 40px; line-height: 30px">CARREGAMENTO</h2>
                      <h2 style="color: #FDB913; font-size: 35px; line-height: 40px; line-height: 30px">LIBERADO</h2>
                    </v-col>
                    <v-col cols="12" style="margin-top: 15px; text-align: center">
                      <img :src="empresa.logoUrl" width="130px">
                    </v-col>
                  </v-row>

                  <v-row dense style="margin-top: 130px; text-align: center" v-if="carregamento.estado == 'CARREGADO' && tipoExibicao == 'PEDIDO'">
                    <v-col cols="12">
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px" v-if="pedidoLocalizado.tipo != 'KW'">{{ pedidoLocalizado.tempo }} {{ pedidoLocalizado.tempo >= 2 ? 'minutos' : 'minuto' }}</h2>
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px" v-if="pedidoLocalizado.tipo == 'KW'">{{ pedidoLocalizado.kwh }} kW/h</h2>
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px">R$ {{ pedidoLocalizado.valor.replace('.',',') }}</h2>
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px" v-if="pedidoLocalizado.statusPedido != 'EM ANÁLISE'">{{ pedidoLocalizado.statusPedido }}</h2>
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px" v-if="pedidoLocalizado.statusPedido == 'CARREGANDO' && pedidoLocalizado.tipo == 'KW'">{{ pedidoLocalizado.kwhRestante.toFixed(2) }} kW/h restantes</h2>
                      <h2 style="color: #E30613; font-size: 30px; line-height: 35px" v-if="pedidoLocalizado.statusPedido == 'CARREGANDO' && pedidoLocalizado.tipo != 'KW'">{{ formatTime(tempo) }} restantes</h2>
                    </v-col>
                    <v-col cols="10" style="margin: 0px auto">
                      <v-alert type="info" color="#E30613" v-if="pedidoLocalizado.statusPedido == 'INTERROMPIDO'">Você possui R$ {{pedidoLocalizado.valorRestante }} de desconto que será aplicado automaticamente em sua próxima recarga</v-alert>
                    </v-col>
                    <v-col cols="12" v-if="pedidoLocalizado.statusPedido == 'CARREGANDO'">
                      <v-btn block style="background: linear-gradient(to bottom, #FDB913, #E30613); border-radius: 10px" large depressed dark :disabled="tempo <= 0" @click="dialogoInterrompePedido = true">
                        <p style="margin: 0px; font-size: 25px">INTERROMPER</p>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <img src="../../assets/LogoBrancoHorizontal.png" width="130px">
        </div>
      </v-container>
    </div>

    <v-dialog v-model="dialogoDadosCartao" persistent max-width="600px">
      <v-card>
        <v-card-title>Dados do cartão</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row dense>
            <v-col cols="12" xs="6" sm="12" md="12" lg="12">
              <v-text-field v-model="cobrancaAsaasCartao.creditCard.holderName" outlined dense label="Nome impresso no cartão*" hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-model="cobrancaAsaasCartao.creditCard.number" outlined dense label="Número do cartão*" v-mask="'#### #### #### ####'" type="tel" hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-model="cobrancaAsaasCartao.creditCard.cpfCnpj" outlined dense label="CPF do titular*" v-mask="'###.###.###-##'" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" type="tel" hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="4">
              <v-text-field v-model="cobrancaAsaasCartao.creditCard.ccv" outlined dense label="CVV*" v-mask="'###'" type="password" hide-details></v-text-field>
            </v-col>
            <v-col cols="6" xs="6" sm="6" md="12" lg="4">
              <v-select v-model="cobrancaAsaasCartao.creditCard.expiryMonth" outlined dense label="Mês de vencimento*" hide-details :items="mesesVencimento" item-text="titulo" item-value="id"></v-select>
            </v-col>
            <v-col cols="6" xs="6" sm="6" md="12" lg="4">
              <v-select v-model="cobrancaAsaasCartao.creditCard.expiryYear" outlined dense label="Ano de vencimento*" hide-details :items="anosVencimento" item-text="titulo" item-value="id"></v-select>
            </v-col>
            <v-col cols="6" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-mask="'#####-###'" v-model="cobrancaAsaasCartao.creditCardHolderInfo.postalCode" label="CEP*" outlined type="tel" dense hide-details required></v-text-field>
            </v-col>
            <v-col cols="6" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.addressNumber" label="Nº do Endereço*" outlined type="tel" dense hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.email" label="E-mail*" outlined type="mail" dense hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field v-model="cliente.telefone" label="WhatsApp*" outlined type="tel" v-mask="'(##) #####-####'" dense hide-details required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox style="padding: 0px; margin-top: 5px" v-model="receberComprovante" label="Receber comprovante pelo WhatsApp"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="dialogoDadosCartao = false" color="red">Voltar</v-btn>
          <v-btn dark text @click="pagarCartaoAsaas" color="#E30613">Pagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoPedeTelefone" persistent max-width="600px">
      <v-card>
        <v-card-title>Informe seus dados</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12">
              <v-text-field outlined dense hide-details v-model="cliente.cpf" type="tel" label="CPF" v-mask="'###.###.###-##'" @blur="consultaCliente"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field outlined dense hide-details v-model="cliente.nome" label="Nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field outlined dense hide-details v-model="cliente.telefone" type="tel" label="Digite seu WhatsApp com DDD" v-mask="'(##) #####-####'"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox style="padding: 0px; margin-top: 0px" v-model="receberComprovante" label="Receber comprovante pelo WhatsApp"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoPedeTelefone = false" color="error">Fechar</v-btn>
          <v-btn text @click="pagamentoPix" color="primary">Pagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoVoucher" persistent max-width="600px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12">
              <v-alert type="info" style="margin: 0px">
                <h3 style="margin: 0px">Voucher: {{ voucher.codigo }}</h3>
                <h3 style="margin: 0px" v-if="voucher.tipo == 'TEMPO'">Tempo: {{ voucher.tempo }} {{ voucher.tempo >= 10 ? 'minutos' : 'minuto' }}</h3>
                <h3 style="margin: 0px" v-if="voucher.tipo == 'KW'">{{ voucher.kwh }} kW/h</h3>
                <h3 style="margin: 0px">Valor: R${{ voucher.valor }}</h3>
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="!clientInLocalStorage">
              <v-text-field outlined dense hide-details v-model="cliente.cpf" type="tel" label="CPF" v-mask="'###.###.###-##'" @blur="consultaCliente"></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!clientInLocalStorage">
              <v-text-field outlined dense hide-details v-model="cliente.nome" label="Nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="!clientInLocalStorage">
              <v-text-field outlined dense hide-details v-model="cliente.telefone" type="tel" label="Digite seu WhatsApp com DDD" v-mask="'(##) #####-####'"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox style="padding: 0px; margin-top: 0px" v-model="receberComprovante" label="Receber comprovante pelo WhatsApp"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoVoucher = false; dialogoInsereVoucher = true" color="error">Voltar</v-btn>
          <v-btn text @click="pagamentoVoucher" color="primary">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoInsereVoucher" persistent max-width="600px">
      <v-card>
        <v-card-title>Digite o voucher</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12">
              <v-text-field outlined dense hide-details v-model="codigoVoucher" label="Voucher"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoInsereVoucher = false; codigoVoucher = ''" color="error">Fechar</v-btn>
          <v-btn text @click="consultaVoucher" color="primary">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoPagamentoPix" persistent max-width="600px"> 
      <v-card>
        <v-card-text style="text-align: center; padding-bottom: 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" style="padding: 10px">
                <p class="texto" style="text-align: left; font-weight: bold;">
                  Copie este código para pagar <b style="color: orange">R$ {{ pix.valor }}</b>:
                </p>
                <ol style="text-align: left; padding-left: 16px; margin: 0;">
                  <li>Acesse seu app de pagamentos.</li>
                  <li>Escolha pagar via Pix.</li>
                  <li>Cole o seguinte código:</li>
                </ol>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                <v-card flat style="padding: 1px" color="white">
                  <qrcode-vue v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'" :value="pix.qrCode" :size="200" level="H" bg-color="white"></qrcode-vue>
                  <img v-else-if="exibirQRCode" :src="pix.qrCode" width="100%" style="max-width: 300px">
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                <p class="texto" style="color:#E30613">Nome Fantasia: REDEGP ESTAÇÕES DE RECARGA</p>
              </v-col>
              <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                <v-text-field
                  v-model="pix.chaveCopiaeCola"
                  label="Chave Pix Copia e Cola"
                  id="chavePix"
                  outlined
                  readonly
                  dense
                  disable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                <v-btn
                  color="#00695C"
                  dark
                  depressed
                  @click="doCopy('chavePix', 'Chave copiada para a área de transferência!')"
                  style="border-radius: 10px; font-weight: bold;"
                >
                  Copiar código
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                <v-btn
                  text
                  color="#00695C"
                  dark
                  @click="exibirQRCode = !exibirQRCode"
                  style="border-radius: 10px; font-size: 14px; "
                >
                  {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text color="primary" @click="dialogoPagamentoPix = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

    <v-dialog v-model="dialogoInterrompePedido" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <v-icon left color="orange">mdi-alert</v-icon>
          ATENÇÃO!
          <v-icon right color="orange">mdi-alert</v-icon>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px" v-if="clienteLocalizado">
          <v-row>
            <v-col cols="12">
              <p>Deseja realmente interromper sua recarga?</p>
              <p style="margin: 0px">Ao interromper, o saldo restante será descontado automaticamente em sua próxima recarga.</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text style="padding-bottom: 0px" v-else>
          <v-row>
            <v-col cols="12">
              <p style="margin: 0px">Ao interromper, o saldo restante será descontado automaticamente em sua próxima recarga.</p>
              <p style="margin: 0px">Informe seu CPF abaixo para interromper a recarga.</p>
            </v-col>
            <v-col cols="12">
              <v-text-field outlined dense hide-details v-model="cliente.cpf" label="CPF" v-mask="'###.###.###-##'"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoInterrompePedido = false" color="primary">Cancelar</v-btn>
          <v-btn text @click="interromperPedido" color="red" :disabled="cliente.cpf.length < 14">Interromper</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="false" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import moment from 'moment'
  import QrcodeVue from "qrcode.vue";
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading
    },

    name: 'RedeGP',

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        contador: null,
        consultaPedido: null,
        isLoading: false,
        fullPage: true,
        dialogoDadosCartao: false,
        dialogoPagamentoPix: false,
        dialogoPedeTelefone: false,
        dialogoVoucher: false,
        dialogoInsereVoucher: false,
        dialogoInterrompePedido: false,
        receberComprovante: true,
        clientInLocalStorage: false,
        carregamento: {
          estado: '',
          texto: '',
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        pix: {
          qrCode: '',
          chaveCopiaeCola: '',
          valor: '',
        },
        exibirQRCode: false,
        tipoExibicao: '',
        bandeiraCartao: '',
        codigoVoucher: '',
        verificaPagamento: 0,
        tempo: 0,
        totem: [],
        empresa: [],
        produtos: [],
        produtoSelecionado: [],
        pedido: [],
        voucher: [],
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        pedidoLocalizado: [],
        cliente: {
          nome: '',
          cpf: '',
          telefone: '',
        },
        cupom: {
          existe: false,
          valor: '',
          id: '',
        },
        bandeiras: [
          {value: 'DINERS', text: "DINERS"},
          {value: 'ELO', text: "ELO"},
          {value: 'HIPERCARD', text: "HIPERCARD"},
          {value: 'MASTERCARD', text: "MASTERCARD"},
          {value: 'VISA', text: "VISA"}
        ],
        clienteLocalizado: false,
      }
    },

    watch: {
      dialogoDadosCartao() {
        if (this.dialogoDadosCartao == true) {
          this.criarAnosVencimento()
          if (localStorage.getItem('compra_c')) {
            let cliente = JSON.parse(localStorage.getItem('compra_c'))

            this.cliente.cpf = cliente.cpf
            this.cobrancaAsaasCartao.creditCard.cpfCnpj = cliente.cpf

            this.cliente.nome = cliente.nome
            this.cobrancaAsaasCartao.creditCard.holderName = cliente.nome

            this.cliente.telefone = cliente.telefone
            this.cliente.id = cliente.id
          }
        } else {
          this.cliente.telefone = ''
          this.cobrancaAsaasCartao.creditCard.cpfCnpj = ''
          this.cobrancaAsaasCartao.creditCard.holderName = ''
        }
      },

      dialogoPagamentoPix() {
        if (this.dialogoPagamentoPix == false) {
          clearInterval(this.verificaPagamento)
        }
      },

      dialogoPedeTelefone() {
        if (this.dialogoPedeTelefone == false) {
          setTimeout(() => {
            let chaves = Object.keys(this.cliente)
  
            for (let i = 0; i < chaves.length; i++) {
              this.cliente[chaves[i]] = ''
            }
          }, 300);
        } else {
          if (localStorage.getItem('compra_c')) {
            let cliente = JSON.parse(localStorage.getItem('compra_c'))

            this.cliente.cpf = cliente.cpf
            this.cliente.nome = cliente.nome
            this.cliente.telefone = cliente.telefone
            this.cliente.id = cliente.id
          }
        }
      },

      dialogoVoucher() {
        if (this.dialogoVoucher == false) {
          setTimeout(() => {
            let chaves = Object.keys(this.cliente)
  
            for (let i = 0; i < chaves.length; i++) {
              this.cliente[chaves[i]] = ''
            }
          }, 300);
        } else {
          if (localStorage.getItem('compra_c')) {
            this.clientInLocalStorage = true
            let cliente = JSON.parse(localStorage.getItem('compra_c'))

            this.cliente.cpf = cliente.cpf
            this.cliente.nome = cliente.nome
            this.cliente.telefone = cliente.telefone
            this.cliente.id = cliente.id
          } else {
            this.clientInLocalStorage = false
          }
        }
      },
    },

    mounted: function () {
      this.getURLParameters()
      this.$validator.localize('pt', this.dictionary)
    },

    beforeDestroy() {
      if (this.verificaPagamento) {
        clearInterval(this.verificaPagamento)
      }

      if (this.contador) {
        clearInterval(this.contador)
      }
    },

    methods: {
      async getURLParameters() {
        this.carregamento.texto = 'Conectando ao servidor'
        this.carregamento.estado = 'CARREGANDO'
        const params = {};
        const queryString = window.location.search.split('?')[1];

        if (queryString) {
          const paramPairs = queryString.split('&');
          paramPairs.forEach(pair => {
            const [key, value] = pair.split('=');
            params[key] = decodeURIComponent(value);
          });
        }

        if (params['q']) {
          this.verificaQRCode(params['q'])
        }

        if (params['p']) {
          this.pegaPedido(params['p'])
        }
      },

      async verificaQRCode(qrCode) {
        await axios.post(baseApiUrl + 'Totens/verificaQrCode', {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            this.totem = response.data.totem
            this.empresa = response.data.empresa
            this.produtos = response.data.produtos
            this.carregamento.texto = 'QR Code válido!'
            this.carregamento.estado = 'CARREGADO'
            this.tipoExibicao = 'SELEÇÃO PRODUTO'
          } else {
            this.carregamento.texto = 'QRCode inválido! Realize a captura novamente.'
            this.carregamento.estado = 'ERRO'
          }
        })
        .catch(error => {
          this.carregamento.texto = error.response.data.error.message
          this.carregamento.estado = 'ERRO'
        })
      },

      async pegaPedido(pedidoId) {
        await axios.post(baseApiUrl + 'Pedidos/consultar', {"pedidoId": pedidoId})
        .then(response => {
          if (response.data) {
            this.pedidoLocalizado = response.data
            this.pedidoLocalizado.id = pedidoId
            this.tempo = response.data.tempoRestanteSegundos
            this.carregamento.estado = 'CARREGADO'
            this.tipoExibicao = 'PEDIDO'
            if (response.data.statusPedido == 'CARREGANDO') {
              if (response.data.tipo == 'KW') {
                this.consultaPedidoKW(pedidoId)
              }
              else {
                this.iniciarContador()
              }
            }

            if (localStorage.getItem('compra_c')) {
              let cliente = JSON.parse(localStorage.getItem('compra_c'))

              this.cliente.cpf = cliente.cpf
              this.cliente.nome = cliente.nome
              this.cliente.telefone = cliente.telefone
              this.cliente.id = cliente.id
              this.clienteLocalizado = true
            }
          } else {
            this.carregamento.texto = 'Pedido não localizado'
            this.carregamento.estado = 'ERRO'
          }
        })
        .catch(error => {
          this.carregamento.texto = error.response.data.error.message
          this.carregamento.estado = 'ERRO'
        })
      },

      escolheProduto(produto) {
        this.produtoSelecionado = produto
        this.tipoExibicao = 'PAGAMENTO'
        this.consultaCupom()
      },

      async criarPedido(formaPagamento, valor, tempo) {
        let vm = this
        let pedido = []
        let dadosPedido = {
          "formaPagamento": formaPagamento,
          "valor": valor ? valor.replace(',','.') : this.produtoSelecionado.preco.replace(',','.'),
          "empresaId": this.empresa.id,
          "telefone": this.cliente.telefone,
          "receberComprovante": this.receberComprovante,
          "totemId": this.totem.id,
          "clienteId": this.cliente.id,
          "cupomId": this.cupom.existe ? this.cupom.id : undefined
        }

        if (this.totem.tipoCarregamento == 'KW') {
          dadosPedido.kwh = this.produtoSelecionado.kwh
        }
        else {
          dadosPedido.tempo = tempo ? tempo : this.produtoSelecionado.tempo
        }

        await axios.post(baseApiUrl + 'Pedidos/criar', dadosPedido)
        .then(response => {
          if (response.data) {
            pedido = response.data
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("red","Problema ao criar pedido, tente novamente!","DESCULPE")
        })

        return pedido
      },

      criarAnosVencimento() {
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14
        this.anosVencimento = []

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      async criarClienteAsaas() {
        let vm = this
        let clienteId = ''
        let dadosCliente = {
          "name": this.cobrancaAsaasCartao.creditCard.holderName,
          "mobilePhone": this.cliente.telefone.replace(/[^\d]+/g,''),
          "empresaId": this.empresa.id,
          "cpfCnpj": this.cobrancaAsaasCartao.creditCard.cpfCnpj,
          "email": this.cobrancaAsaasCartao.creditCardHolderInfo.email,
          "postalCode": this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode,
          "addressNumber": this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber,
          "notificationDisabled": true,
        }

        await axios.post(baseApiUrl + 'Pagamentos/criarCliente', dadosCliente)
        .then(response => {
          if (response.data) {
            clienteId = response.data.id
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825","Problema ao criar cliente, tente novamente!","DESCULPE")
        })

        return clienteId
      },

      async pagamentoPix() {
        let vm = this

        if (!this.cliente.nome || !this.cliente.cpf || this.cliente.telefone.length < 15) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todas as informações corretamente", "ATENÇÃO")
        }
        else if (!CpfValidate(this.cliente.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe um CPF válido!", "ATENÇÃO")
        }
        else {
          if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
            this.pagarPixTaPago()
          } else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
            this.pagarPixSicoob()
          }
        }
      },

      async pagarPixTaPago() {
        let vm = this
        this.isLoading = true
        await this.criaCliente(this.cliente)
        let pedido = await this.criarPedido('PIX', null, null)

        if (pedido.id) {
          let dadosCobranca = {
            "empresaId": this.empresa.id,
            "pedidoId": pedido.id,
            "valor": parseFloat(this.produtoSelecionado.preco.replace(',','.')),
            "descricao": 'Referente ao pagamento de ' + this.produtoSelecionado.descricao.toUpperCase() + ' na ' + this.empresa.nome
          }

          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dadosCobranca)
          .then(response => {
            if (response.data) {
              this.pix.qrCode = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
              this.pix.chaveCopiaeCola = response.data.instantPayment.textContent
              this.dialogoPedeTelefone = false
              this.dialogoPagamentoPix = true
              this.isLoading = false
              this.atualizaPedido(pedido)
              this.consultaPagamentoPixTaPago(pedido)
            }
          })
          .catch(() => {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("red","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          })
        } else {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("red","Verifique os campos preenchidos e tente novamente!","DESCULPE")
        }
      },

      async consultaPagamentoPixTaPago(pedido) {
        var vm = this
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"pedidoId": pedido.id, "empresaId": this.empresa.id})
          .then(async response => {
            if (response.data.status == 'APPROVED') {
              clearInterval(this.verificaPagamento);
              pedido.statusPagamento = "PAGO"
              await this.atualizaPedido(pedido)
              this.tipoExibicao = 'FINALIZADO'
              this.dialogoPagamentoPix = false
            }
          })
          .catch(() => {
            this.dialogoPagamentoPix = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
          })
        }.bind(this), 5000)
      },

      async pagarPixSicoob() {
        let vm = this
        this.isLoading = true
        await this.criaCliente(this.cliente)

        let dadosCobranca = {
          "empresaId": this.empresa.id,
          "devedor": {
            "cpf": this.cliente.cpf,
            "nome": this.cliente.nome
          },
          "valor": {
            "original": ""
          },
          "chave": "",
          "solicitacaoPagador": 'Referente ao pagamento de ' + this.produtoSelecionado.descricao.toUpperCase() + ' na ' + this.empresa.nome,
          "produtoId": this.produtoSelecionado.id,
          "clienteId": this.cliente.id,
          "formaPagamento": 'PIX',
          "totemId": this.totem.id,
          "cupomId": this.cupom.id,
          "receberComprovante": true,
        }

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
        .then(response => {
          if (response.data) {
            this.pix.qrCode = response.data.brcode
            this.pix.chaveCopiaeCola = response.data.brcode
            this.pix.id = response.data.txid
            this.pix.valor = response.data.valor.original.replace('.',',')
            this.dialogoPedeTelefone = false
            this.dialogoPagamentoPix = true
            this.isLoading = false
            this.consultaPagamentoPixSicoob()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("red","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
        })
      },

      async consultaPagamentoPixSicoob() {
        try {
          this.verificaPagamento = setInterval(
            async function () {
              await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"paymentId": this.pix.id})
              .then(async res3 => {
                if (res3.data.status == "APPROVED") {
                  clearInterval(this.verificaPagamento);
                  this.tipoExibicao = 'FINALIZADO'
                  this.dialogoPagamentoPix = false
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaPagamento);
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
        }
      },

      async pagarCartaoAsaas() {
        let vm = this

        if (
          !this.cobrancaAsaasCartao.creditCard.holderName || !this.cobrancaAsaasCartao.creditCard.number || !this.cobrancaAsaasCartao.creditCard.cpfCnpj ||
          !this.cobrancaAsaasCartao.creditCard.ccv || !this.cobrancaAsaasCartao.creditCard.expiryMonth || !this.cobrancaAsaasCartao.creditCard.expiryYear ||
          !this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode || !this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber ||
          !this.cobrancaAsaasCartao.creditCardHolderInfo.email || !this.cliente.telefone
        ) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        } else if (!CpfValidate(this.cobrancaAsaasCartao.creditCard.cpfCnpj)) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um CPF válido!","ATENÇÃO")
        } else {
          this.isLoading = true

          let dados = {
            "nome": this.cobrancaAsaasCartao.creditCard.holderName,
            "cpf": this.cobrancaAsaasCartao.creditCard.cpfCnpj,
            "telefone": this.cliente.telefone
          }
          this.criaCliente(dados)

          let idCliente = await this.criarClienteAsaas()

          if (idCliente) {
            this.cobrancaAsaasCartao.customer = idCliente
            this.cobrancaAsaasCartao.billingType = 'CREDIT_CARD'
            // this.cobrancaAsaasCartao.value = parseFloat(this.produtoSelecionado.preco.replace(',','.'))
            this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaasCartao.description = 'Referente ao pagamento de ' + this.produtoSelecionado.descricao.toUpperCase() + ' na ' + this.empresa.nome
            this.cobrancaAsaasCartao.empresaId = this.empresa.id
            this.cobrancaAsaasCartao.remoteIp = await this.pegaIp()
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj = this.cobrancaAsaasCartao.creditCard.cpfCnpj
            this.cobrancaAsaasCartao.creditCardHolderInfo.name = this.cobrancaAsaasCartao.creditCard.holderName
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone = this.cliente.telefone.replace(/[^\d]+/g,'')
            this.cobrancaAsaasCartao.produtoId = this.produtoSelecionado.id
            this.cobrancaAsaasCartao.clienteId = this.cliente.id
            this.cobrancaAsaasCartao.cupomId = this.cupom.id
            this.cobrancaAsaasCartao.formaPagamento = 'CARTAO'
            this.cobrancaAsaasCartao.receberComprovante = this.receberComprovante
            this.cobrancaAsaasCartao.totemId = this.totem.id

            await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaasCartao)
            .then(response => {
              if (response.data.cobranca.status == 'CONFIRMED') {
                this.isLoading = false
                this.dialogoDadosCartao = false
                this.tipoExibicao = 'FINALIZADO'
              }
            })
            .catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("red","Problema ao efetuar pagamento, tente novamente!","DESCULPE")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("red","Verifique os campos preenchidos e tente novamente!","DESCULPE")
          }
        }
      },

      async pagamentoVoucher() {
        let vm = this

        if (!this.cliente.cpf || !this.cliente.nome || !this.cliente.telefone || !this.codigoVoucher) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        }
        else if (!CpfValidate(this.cliente.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um CPF válido!","ATENÇÃO")
        }
        else {
          this.isLoading = true
          await this.criaCliente(this.cliente)
          let pedido = await this.criarPedido('VOUCHER', this.voucher.valor, this.voucher.tempo)

          if (pedido.id) {
            let dadosCobranca = {
              "empresaId": this.empresa.id,
              "pedidoId": pedido.id,
              "voucher": this.codigoVoucher.toUpperCase(),
            }

            await axios.post(baseApiUrl + 'Pagamentos/voucherCobranca', dadosCobranca)
            .then(response => {
              if (response.data) {
                this.isLoading = false
                this.dialogoVoucher = false
                this.tipoExibicao = 'FINALIZADO'
              }
            })
            .catch(error => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("red","Verifique os campos preenchidos e tente novamente!","DESCULPE")
          }
        }
      },

      async pegaIp() {
        let ip

        await axios.get('https://api.ipify.org/?format=json')
        .then(response => {
          ip = response.data.ip ? response.data.ip : '127.0.0.1'
        })

        return ip
      },

      async atualizaPedido(pedido, callback) {
        await axios.patch(baseApiUrl + 'Pedidos/' + pedido.id, pedido)
        if (callback) {
          callback()
        }
      },

      doCopy(id, texto) {
        let vm = this
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          vm.$refs.chamaSnackbar.snack("blue", texto, "INFORMAÇÃO")
        } catch (error) {
          this.snackbar = true
          vm.$refs.chamaSnackbar.snack("red", "Problema ao efetuar cópia para a área de transferência", "DESCULPE")
        }
      },

      async criaCliente(dados) {
        await axios.post(baseApiUrl + 'Clientes/criar', dados)
        .then(response => {
          if (response.data) {
            this.cliente = response.data
            localStorage.setItem('compra_c', JSON.stringify(response.data))
          }
        })
      },

      async consultaCliente() {
        let vm = this

        if (CpfValidate(this.cliente.cpf)) {
          await axios.post(baseApiUrl + 'Clientes/buscar', {"cpf": this.cliente.cpf})
          .then(response => {
            if (response.data) {
              this.cliente.nome = response.data.nome
              this.cliente.telefone = response.data.telefone
              this.cliente.id = response.data.id
              localStorage.setItem('compra_c', JSON.stringify(response.data))
              this.consultaCupom()
            } else {
              this.cliente.nome = ''
              this.cliente.telefone = ''
              this.cliente.id = undefined
              localStorage.removeItem('compra_c')
            }
          })
          .catch(() => {
            this.cliente.nome = ''
            this.cliente.telefone = ''
            this.cliente.id = undefined
            localStorage.removeItem('compra_c')
          })
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe um CPF válido!", "ATENÇÃO")
        }
      },

      async consultaVoucher() {
        let vm = this
        this.isLoading = true

        await axios.post(baseApiUrl + 'Vouchers/consultar', { 'empresaId': this.empresa.id, 'voucher': this.codigoVoucher.toUpperCase() })
        .then(response => {
          if (response.data) {
            if (response.data.status == 'LIVRE') {
              this.voucher = response.data
              this.dialogoInsereVoucher = false
              this.dialogoVoucher = true
            }
            else {
              vm.$refs.chamaSnackbar.snack("orange", "Voucher informado não pode ser utilizado", "ATENÇÃO")
            }
          }
          else {
            vm.$refs.chamaSnackbar.snack("orange", "Voucher inválido", "ATENÇÃO")
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("red", "Voucher inválido", "ATENÇÃO")
        })

        this.isLoading = false
      },

      iniciarContador() {
        this.contador = setInterval(() => {
          if (this.tempo > 0) {
            this.tempo--;
          } else {
            clearInterval(this.contador);
            this.pegaPedido(this.pedidoLocalizado.id)
          }
        }, 1000);
      },

      formatTime(value) {
        const minutes = Math.floor(value / 60).toString().padStart(2, '0');
        const seconds = (value % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
      },

      async interromperPedido() {
        let vm = this
        this.isLoading = true

        await axios.post(baseApiUrl + 'Pedidos/interromperCpf', {"pedidoId": this.pedidoLocalizado.id, "cpf": this.cliente.cpf})
        .then(response => {
          if (response.data) {
            clearInterval(this.contador)
            this.pegaPedido(this.pedidoLocalizado.id)
            this.dialogoInterrompePedido = false
          }
        })
        .catch(error => {
          vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "ATENÇÃO")
        })

        this.isLoading = false
      },

      voltaTelaSelecaoProdutos() {
        this.tipoExibicao = 'SELEÇÃO PRODUTO'
        this.produtoSelecionado = []
        this.cupom.existe = false
        this.cupom.valor = ''
      },

      async consultaCupom() {
        if (localStorage.getItem('compra_c')) {
          let cliente = JSON.parse(localStorage.getItem('compra_c'))

          await axios.post(baseApiUrl + 'Cupons/consultar', {"clienteId": cliente.id})
          .then(response => {
            if (response.data) {
              this.cupom.existe = true
              this.cupom.valor = response.data.valor
              this.cupom.id = response.data.id
            }
            else {
              this.cupom.existe = false
              this.cupom.valor = ""
              this.cupom.id = ""
            }
          })
          .catch(() => {
            this.cupom.existe = false
            this.cupom.valor = ""
            this.cupom.id = ""
          })
        }
      },

      verificaValorCartao() {
        let vm = this

        if (
          (parseFloat(this.produtoSelecionado.preco.replace(',','.')) >= 5) || 
          ((parseFloat(this.produtoSelecionado.preco.replace(',','.')) - parseFloat(this.cupom.valor.replace(',','.'))) >= 5)
        ) {
          this.dialogoDadosCartao = true
        } else {
          vm.$refs.chamaSnackbar.snack("orange","Forma de pagamento não disponivel para valores inferiores a R$5,00.","ATENÇÃO")
        }
      },

      async consultaPedidoKW(pedidoId) {
        this.consultaPedido = setInterval(async () => {
          await axios.post(baseApiUrl + 'Pedidos/consultar', {"pedidoId": pedidoId})
          .then(response => {
            this.pedidoLocalizado = response.data

            if (response.data.statusPedido != 'CARREGANDO') {
              clearInterval(this.consultaPedido)
            }
          })
        }, 10000);
      },
    }
  }
</script>

<style scoped>
  @import '../../assets/styles.css';

  .font-example {
    font-family: 'Montserrat', sans-serif;
  }

  /* LOGIN */
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #E30613 0%, #D91C1C 30%, #FDB913 60%, #FFD966 70%, #0099CC 100%);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>


